import React, { useState, useEffect } from "react";
import {
  makeStyles,
  Paper,
  Container,
} from "@material-ui/core";
import Page from "src/components/Page";
import actions from "src/duck/global/actions";
import { connect } from "react-redux";
import { useTheme } from "@material-ui/core/styles";
import { useNavigate } from "react-router-dom";
import { momentLocalizer } from "react-big-calendar";
import moment from "moment";
import KmPageTitle from "src/components/layout/KmPageTitle";
import CalendarView from "./CalendarView";
import AppBar from "@material-ui/core/AppBar";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import KmTabPanel from "src/components/common/KmTabPanel";
import { useParams } from "react-router";
import { userHasAtLeastOnePermission } from "src/utils/userutils";
import EventsView from "./EventsView";

const useStyles = makeStyles((theme) => ({
  root: {
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
  massagebox: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  title: {
    marginLeft: theme.spacing(3.5),
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    flexGrow: 1,
  },
}));

const localizer = momentLocalizer(moment);

const CalendarTabView = ({
  globalData,
  enableGlobalLoader,
  disableGlobalLoader,
}) => {
  const classes = useStyles();

  const labelToTabs = {
    widok: 0,
    zarzadzaniewydarzenia: 1,
  };

  const { tabId, pageId, rowsCount } = useParams();
  const [value, setValue] = React.useState(
    labelToTabs[tabId] ? labelToTabs[tabId] : 0
  );

  const [reloadCounter, setReloadCounter] = useState(0);
  const theme = useTheme();
  const navigate = useNavigate();

  function a11yProps(index) {
    return {
      id: `scrollable-auto-tab-${index}`,
      "aria-controls": `scrollable-auto-tabpanel-${index}`,
    };
  }

  const handleChange = (event, newValue) => {

    let tab = Object.keys(labelToTabs).find(
      (key) => labelToTabs[key] === newValue
    );

    setValue(newValue);

    if (tab) {
      navigate(`/kalendarz/${tab}`);
    } else {
      navigate("/kalendarz");
    }
  };

  return (
    <Page className={classes.root} title="Kalendarz">
      <KmPageTitle>Kalendarz</KmPageTitle>
      {userHasAtLeastOnePermission(globalData, [
        "user_admin",
        "super_admin",
      ]) ? (
        <Container maxWidth={false}>
          <Paper>
            <AppBar position="static" color="default">
              <Tabs
                value={value}
                onChange={handleChange}
                indicatorColor="primary"
                variant="scrollable"
                scrollButtons="on"
                aria-label="scrollable auto tabs example"
              >
                <Tab label="Kalendarz" {...a11yProps(0)} />
                <Tab label="Wydarzenia" {...a11yProps(1)} />
              </Tabs>
            </AppBar>
            <KmTabPanel value={value} index={0}>
              <CalendarView></CalendarView>
            </KmTabPanel>
            <KmTabPanel value={value} index={1}>
              <EventsView></EventsView>
            </KmTabPanel>
          </Paper>
        </Container>
      ) : (
        <Container maxWidth={false}>
          <Paper>
            <CalendarView></CalendarView>
          </Paper>
        </Container>
      )}
    </Page>
  );
};

const mapStateToProps = (state) => ({
  globalData: state.globalData,
});

const mapDispatchToProps = (dispatch) => ({
  enableGlobalLoader: () => dispatch(actions.enableGlobalLoader()),
  disableGlobalLoader: () => dispatch(actions.disableGlobalLoader()),
});

export default connect(mapStateToProps, mapDispatchToProps)(CalendarTabView);
